import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'Lord Henri of Bourscheid stands before his keep, a steward at his shoulder. He looks you over without warmth.',
    options: [
      { text: 'Bow and greet him.', nextDialogId: 'greet' },
      { text: 'Wait to be addressed.', nextDialogId: 'wait' },
    ],
  },
  {
    id: 'greet',
    type: DialogType.dialog,
    text: 'A traveller. State your business, or be brief. A lord has cares enough without strangers at his gate.',
    options: [
      { text: 'What cares, my lord?', nextDialogId: 'cares' },
      { text: 'I am only passing through.', nextDialogId: 'pass' },
    ],
  },
  {
    id: 'cares',
    type: DialogType.dialog,
    text: 'The land all but governs itself these days. Our count is forever elsewhere.',
    options: [
      { text: 'Where is the count?', nextDialogId: 'count' },
      { text: 'I will not keep you, my lord.', nextDialogId: 'pass' },
    ],
  },
  {
    id: 'count',
    type: DialogType.dialog,
    text: 'Charles wears the Roman crown and holds court in Prague. Luxembourg is a small jewel in a large hand now.',
    options: [
      { text: 'Who will hold it, then?', nextDialogId: 'heir' },
      { text: 'I understand, my lord.', nextDialogId: 'pass' },
    ],
  },
  {
    id: 'heir',
    type: DialogType.dialog,
    text: 'His young half-brother, Wenceslaus, when the boy is grown. Until then, men like me hold the land and answer for it.',
    options: [{ text: 'Thank you for your time, my lord.', nextDialogId: 'pass' }],
  },
  {
    id: 'wait',
    type: DialogType.description,
    text: 'You hold your tongue. He tires of the silence soon enough and speaks first.',
    options: [{ text: '(Listen.)', nextDialogId: 'greet' }],
  },
  {
    id: 'pass',
    type: DialogType.dialog,
    text: 'Then go, and keep to the road. May your journey be safe.',
    options: [{ text: 'Leave.', nextDialogId: 'start' }],
  },
];
